/**
 * GET-GENERATIVE-ASSISTANT-SUMMARY.UTILS
 * Return response from chatGPT from summarize comments
 */

import { Question } from "@/redux/question.types"
import { SocketCreate } from "./socketio.utils"
import { store } from ".."

//Max delay to get a full summary before giving up (the service can hang without ever
//emitting "response" nor "error", eg. if it crashes or is unreachable)
const SUMMARY_TIMEOUT_DELAY: number = 60000

const getGenerativeAssistantSummary = async (
  question: Question,
  label: string,
  comments: string[],
  useBullets: boolean
) => {
  //Init websocket
  const socket = SocketCreate()

  //Init output summary
  let summary: string = ""

  //Create promise that will return a result once data is returned
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      cleanup()
      reject({ message: "assistant_service_unavailable" })
    }, SUMMARY_TIMEOUT_DELAY)

    function cleanup() {
      clearTimeout(timeoutId)
      socket.disconnect()
    }

    socket.on("connect_error", (error) => {
      cleanup()
      reject({ message: "assistant_service_unavailable", details: error })
    })

    socket.connect()

    socket.emit(
      question.isPromptCustom ? "ask" : "summarize",
      {
        comments: question.isPromptCustom && question.prompt ? [] : comments,
        prompt: question.getPromptFormatted(comments, store.getState()._session.userInitialLanguage, label),
        questionLabel: question.label,
        useBullets
      },
      store.getState()._session.userInitialLanguage
    )

    socket.on("response", (token: string, finishReason: string | null) => {
      summary = summary + token
      if (finishReason === "length" || finishReason === "stop") {
        cleanup()
        resolve(summary)
      }
    })

    socket.on("error", (error) => {
      cleanup()
      reject(error)
    })
  })
}

export default getGenerativeAssistantSummary
